//
// KeyValueKey.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var KeyValueKey = {
    AUTO:0,
    CATEGORYVALUE:1,
    RESPONSEVALUE:2
};
export default KeyValueKey;
